// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const InstanceRole = {
  SuperUser: "super_user",
  ServiceAccount: "service_account",
  TenantManager: "tenant_manager",
  ContentManager: "content_manager",
  ServiceDesk: "service_desk",
} as const;
export type InstanceRole = (typeof InstanceRole)[keyof typeof InstanceRole];

export function instanceOfInstanceRole(value: any): boolean {
  for (const key in InstanceRole) {
    if (Object.prototype.hasOwnProperty.call(InstanceRole, key)) {
      if (InstanceRole[key as keyof typeof InstanceRole] === value) {
        return true;
      }
    }
  }
  return false;
}

export function InstanceRoleFromJSON(json: any): InstanceRole {
  return InstanceRoleFromJSONTyped(json, false);
}

export function InstanceRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceRole {
  return json as InstanceRole;
}

export function InstanceRoleToJSON(value?: InstanceRole | null): any {
  return value as any;
}

export function InstanceRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): InstanceRole {
  return value as InstanceRole;
}
